import { useDetailApi } from "../../../swr/useApi";
import type { CountryDto } from "../../../api";
import { countriesService } from "../../api_client";

export function useCountry(id?: number | null) {
    return useDetailApi<CountryDto>({
        key: `country-${id ?? "none"}`,
        serviceMethod: async () =>
            await countriesService.getCountryById(id as number),
        options: {
            isPaused: () => !id,
        },
    });
}
